import "../styles/demo.scss";
import Nav from "./Nav";
import Footer from "./Footer";
import PageMeta from "./PageMeta";
import StoreCta from "./StoreCta";
import { FadeInUp, StaggerChildren, StaggerItem } from "./motion";
import { demoHero, demoSteps, demoMeta } from "../content/demo";
import {
  organizationSchema,
  buildHowToSchema,
  buildBreadcrumbSchema,
  innerPageBreadcrumbs,
} from "../content/seo";

const Demo = () => {
  const howToSchema = buildHowToSchema(demoSteps);
  const breadcrumbSchema = buildBreadcrumbSchema(innerPageBreadcrumbs.demo);

  return (
    <main className="demo">
      <PageMeta
        meta={demoMeta}
        jsonLd={[organizationSchema, howToSchema, breadcrumbSchema]}
      />
      <Nav page="demo" />
      <FadeInUp as="header" className="page-hero">
        <h1>{demoHero.title}</h1>
        <p>{demoHero.subtitle}</p>
      </FadeInUp>
      <StaggerChildren className="instructions_row">
        {demoSteps.map((step, index) => (
          <StaggerItem as="article" className="demo-step" key={step.title}>
            <img src={step.image} alt={step.alt} />
            <div className="demo-step__instructions">
              <span className="demo-step__number">{index + 1}</span>
              <h2>{step.title}</h2>
              <p>{step.description}</p>
              {step.duration ? (
                <p className="demo-step__duration">Approx. {step.duration}</p>
              ) : null}
            </div>
          </StaggerItem>
        ))}
      </StaggerChildren>
      <FadeInUp>
        <StoreCta className="content-cta" />
      </FadeInUp>
      <Footer />
    </main>
  );
};

export default Demo;
